import { render, staticRenderFns } from "./classstatistics.vue?vue&type=template&id=ea274c9a&scoped=true"
import script from "./classstatistics.vue?vue&type=script&lang=js"
export * from "./classstatistics.vue?vue&type=script&lang=js"
import style0 from "./classstatistics.vue?vue&type=style&index=0&id=ea274c9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea274c9a",
  null
  
)

export default component.exports